import { TranslateFunc } from 'src/components/translate';
import {
  FilterSelection,
  FilterType,
  IFilter,
} from 'src/components/price-list/types';
import { getFractalRepresentation } from '../size-variants/utils';
import { getColorTranslation } from '../color-variants/utils/colors';
import { getConditionName } from '../../product-conditions/utils';

export const createNewSelection = (
  variant: string | null,
  variantSelection: FilterSelection
) => {
  if (!variant) {
    return [];
  }
  return variantSelection.includes(variant)
    ? variantSelection.filter((v: string) => v !== variant)
    : [...variantSelection, variant];
};

export const getSelectionsString = (t: TranslateFunc, filter?: IFilter) => {
  const selected = filter?.active ? filter?.selection : null;
  if (!selected?.length) {
    return null;
  }
  const prettified = selected.map(variant => {
    switch (filter?.type) {
      case FilterType.CONDITION:
        return variant === 'used' ? getConditionName(variant, t) : null;
      case FilterType.VARIANT_SIZE:
        return getFractalRepresentation(variant);
      case FilterType.VARIANT_COLOR:
        return getColorTranslation(t, variant);
      default:
        return variant;
    }
  });
  return prettified.sort().join(', ');
};
